<template>
  <div class="card">
    <form-wizard
      title=""
      subtitle=""
      color="var(--primary)"
      @on-complete="submitJob"
      ref="wizard"
    >
      <tab-content
        title="Type & Client"
        icon="lni lni-user"
        :before-change="typeAndClientVerify"
      >
        <form-base
          class="maxWidth1000"
          :submit-status="submitStatus"
          :errors="errors"
          :loading="loading"
        >
          <template v-slot:fields>
            <form-group label="Client Type">
              <b-form-radio
                v-model="clientType"
                name="clientType"
                value="partner"
                @change="getPartners()"
                >Partner (Insurer,Broker,Repair Centre)</b-form-radio
              >
              <b-form-radio
                v-model="clientType"
                name="clientType"
                value="client"
                @change="
                  selectedPartner = null;
                  job = {};
                "
                >Client (Walk-in)</b-form-radio
              >
            </form-group>

            <div v-if="clientType">
              <form-group label="Select Partner" v-if="clientType == 'partner'">
                <b-skeleton type="input" v-show="loading"></b-skeleton>
                <v-select
                  label="name"
                  :options="partners"
                  v-show="!loading"
                  v-model="selectedPartner"
                >
                  <template slot="option" slot-scope="p">
                    <div>
                      {{ p.name }} - {{ p.contact_number }}<br />
                      {{ p.email_address }}
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="p">
                    {{ p.name }} -
                    <small
                      v-if="p.is_shipping_required == 1"
                      class="text-muted font-italic"
                      >Partner requires shipping</small
                    >
                  </template>
                </v-select>
                <small v-if="$v.selectedPartner.$error" class="text-danger">
                  Please select partner
                </small>
              </form-group>

              <form-group label="Select Client" v-if="clientType == 'client'">
                <v-select
                  label="name"
                  :options="clients"
                  :filterable="false"
                  @search="getClients"
                  v-model="selectedClient"
                >
                  <template slot="no-options">
                    Type to search clients by name or contact number
                  </template>
                  <template slot="option" slot-scope="c">
                    <div>
                      {{ c.name }} - {{ c.contact_number }}<br />
                      {{ c.email_address }}
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="c">
                    {{ c.name }}
                  </template>
                </v-select>

                <small v-if="$v.selectedClient.$error" class="text-danger">
                  Please select client
                </small>

                <button
                  class="btn btn-sm btn-success mt-2"
                  @click="clientCreate"
                >
                  Create client
                </button>
              </form-group>

              <!-- Shipping required -->
              <form-group label="Shipping Required">
                <b-form-radio
                  v-model="job.is_shipping_required"
                  name="jobRequiresShipping"
                  value="1"
                  >Yes collection to be arranged</b-form-radio
                >
                <b-form-radio
                  v-model="job.is_shipping_required"
                  name="jobRequiresShipping"
                  value="0"
                  >No, Device is here</b-form-radio
                >
              </form-group>

              <!-- Insurance Job Client Details -->

              <div
                v-if="
                  selectedPartner != null &&
                  selectedPartner.is_insurance_jobs == 1
                "
              >
                <hr />
                <h5 class="text-primary">Insurance Claim Details</h5>

                <form-group label="Policy Number" :required="true">
                  <input
                    @blur="$v.job.policy_number.$touch"
                    :class="{ 'is-invalid': $v.job.policy_number.$error }"
                    type="text"
                    class="form-control"
                    v-model="job.policy_number"
                  />
                </form-group>

                <form-group label="SPM Number">
                  <input
                    type="text"
                    class="form-control"
                    v-model="job.spm_number"
                  />
                </form-group>

                <form-group label="Claim Number" :required="true">
                  <input
                    type="text"
                    @blur="$v.job.claim_number.$touch"
                    :class="{ 'is-invalid': $v.job.claim_number.$error }"
                    class="form-control"
                    v-model="job.claim_number"
                  />
                </form-group>

                <form-group label="Scheme" :required="true">
                  <v-select
                    @blur="$v.job.scheme_id.$touch"
                    :class="{ 'is-invalid': $v.job.scheme_id.$error }"
                    label="scheme"
                    :reduce="(scheme) => scheme.id"
                    :options="selectedPartner.schemes"
                    v-show="!loading"
                    v-model="job.scheme_id"
                  >
                    <template slot="option" slot-scope="s">
                      <div>
                        {{ s.name }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="s">
                      {{ s.name }}
                      <small
                        v-if="s.full_cover == 1"
                        class="text-muted font-italic"
                      >
                        - Full Cover</small
                      >
                    </template>
                  </v-select>

                  <small v-if="$v.job.scheme_id.$error" class="text-danger">
                    Please select scheme
                  </small>
                </form-group>

                <div v-if="job.scheme_id != null && !schemeFullCover()">
                  <form-group label="Client Excess" :required="true">
                    <b-form-radio
                      v-model="job.excess_calculation_type"
                      name="excessType"
                      value="percentage"
                      @change="job.excess_amount = null"
                      >% Percentage based</b-form-radio
                    >
                    <b-form-radio
                      v-model="job.excess_calculation_type"
                      name="excessType"
                      value="amount"
                      @change="job.excess_percentage = null"
                      >Amount based</b-form-radio
                    >
                  </form-group>

                  <form-group label="Excess" :required="true">
                    <div
                      class="input-group w-25"
                      v-if="job.excess_calculation_type == 'percentage'"
                    >
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1"
                          >%</span
                        >
                      </div>
                      <input
                        type="number"
                        min="0"
                        class="form-control"
                        @blur="$v.job.excess_percentage.$touch"
                        :class="{
                          'is-invalid': $v.job.excess_percentage.$error,
                        }"
                        v-model="job.excess_percentage"
                      />
                    </div>

                    <input
                      v-if="job.excess_calculation_type == 'amount'"
                      type="number"
                      min="0"
                      class="form-control w-25"
                      @blur="$v.job.excess_amount.$touch"
                      :class="{ 'is-invalid': $v.job.excess_amount.$error }"
                      v-model="job.excess_amount"
                    />
                  </form-group>
                </div>

                 <form-group label="Device Replacement Price"  v-if="job.scheme_id != null">
                    <input
                      type="number"
                      min="0"
                      class="form-control w-25"                     
                      v-model="job.replacement_price"
                    />
                  </form-group>

                <hr />
                <h5 class="text-primary">Insurance Client Details</h5>

                <form-group label="Name" :required="true">
                  <input
                    type="text"
                    class="form-control"
                    @blur="$v.insuranceJobClient.name.$touch"
                    :class="{ 'is-invalid': $v.insuranceJobClient.name.$error }"
                    v-model="insuranceJobClient.name"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="!$v.insuranceJobClient.name.required"
                  >
                    Please enter name
                  </div>
                </form-group>

                <form-group label="Surname" :required="true">
                  <input
                    type="text"
                    @blur="$v.insuranceJobClient.surname.$touch"
                    class="form-control"
                    :class="{
                      'is-invalid': $v.insuranceJobClient.surname.$error,
                    }"
                    v-model="insuranceJobClient.surname"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="!$v.insuranceJobClient.surname.required"
                  >
                    Please enter surname
                  </div>
                </form-group>

                <input
                  hidden="insuranceJobClient.client_type"
                  value="Partner client"
                />

                <form-group label="ID Number">
                  <input
                    type="text"
                    class="form-control"
                    v-model="insuranceJobClient.id_number"
                  />
                </form-group>

                <form-group label="Contact Number" :required="true">
                  <input
                    type="text"
                    class="form-control"
                    v-model="insuranceJobClient.contact_number"
                    @blur="$v.insuranceJobClient.contact_number.$touch"
                    :class="{
                      'is-invalid': $v.insuranceJobClient.contact_number.$error,
                    }"
                  />
                </form-group>

                <form-group label="Contact Number 2">
                  <input
                    type="text"
                    class="form-control"
                    v-model="insuranceJobClient.contact_number_2"
                  />
                </form-group>

                <form-group label="Email" :required="true">
                  <input
                    type="email"
                    class="form-control"
                    v-model="insuranceJobClient.email_address"
                    @blur="$v.insuranceJobClient.email_address.$touch"
                    :class="{
                      'is-invalid': $v.insuranceJobClient.email_address.$error,
                    }"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="!$v.insuranceJobClient.email_address.required"
                  >
                    Please enter email address
                  </div>
                  <div
                    class="invalid-feedback"
                    v-if="!$v.insuranceJobClient.email_address.email"
                  >
                    Please enter valid email
                  </div>
                </form-group>

                <form-group label="Address" :required="true">
                 <textarea-autosize
                    class="form-control"
                    v-model="insuranceJobClient.address"
                    @blur="$v.insuranceJobClient.address.$touch"
                    :class="{
                      'is-invalid': $v.insuranceJobClient.address.$error,
                    }"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="!$v.insuranceJobClient.address.required"
                  >
                    Please enter address
                  </div>
                </form-group>

                <form-group label="City">
                  <input
                    type="text"
                    class="form-control"
                    v-model="insuranceJobClient.city"
                  />
                </form-group>

                <form-group label="Postal Code" :required="true">
                  <input
                    type="text"
                    class="form-control"
                    v-model="insuranceJobClient.postal_code"
                    @blur="$v.insuranceJobClient.postal_code.$touch"
                    :class="{
                      'is-invalid': $v.insuranceJobClient.postal_code.$error,
                    }"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="!$v.insuranceJobClient.postal_code.required"
                  >
                    Please enter code
                  </div>
                </form-group>

                <form-group label="Province" :required="true">
                  <b-form-select v-model="insuranceJobClient.province_id">
                    <b-form-select-option
                      v-for="pr in provinces"
                      :value="pr.id"
                      :key="pr.id"
                      >{{ pr.province }}</b-form-select-option
                    >
                  </b-form-select>
                  <div
                    class="invalid-feedback"
                    v-if="!$v.insuranceJobClient.province_id.required"
                  >
                    Please enter email province
                  </div>
                </form-group>

                <form-group label="VAT Number">
                  <input
                    type="text"
                    class="form-control"
                    v-model="insuranceJobClient.vat_number"
                  />
                </form-group>
              </div>
            </div>
          </template>
        </form-base>
      </tab-content>
      <tab-content
        title="Device"
        icon="lni lni-laptop-phone"
        :before-change="deviceVerify"
      >
        <form-base
          class="maxWidth1000"
          :submit-status="submitStatus"
          :errors="errors"
          :loading="loading"
        >
          <template v-slot:fields>
            <form-group label="Device Type" :required="true">
              <b-skeleton type="input" v-show="loading"></b-skeleton>
              <v-select
                label="description"
                @input="clearModel"
                :reduce="(deviceType) => deviceType.id"
                :options="deviceTypes"
                v-show="!loading"
                v-model="job.device_type_id"
              >
                <template slot="option" slot-scope="dt">
                  <div>{{ dt.code }} - {{ dt.description }}</div>
                </template>
                <template slot="selected-option" slot-scope="dt">
                  {{ dt.description }}
                </template>
              </v-select>
              <small v-if="$v.job.device_type_id.$error" class="text-danger">
                Please select type
              </small>
            </form-group>

            <form-group label="Manufacture" :required="true">
              <b-skeleton type="input" v-show="loading"></b-skeleton>
              <v-select
                label="description"
                @input="clearModel"
                :reduce="(manufacture) => manufacture.id"
                :options="manufactures"
                v-show="!loading"
                v-model="job.manufacture_id"
              >
                <template slot="option" slot-scope="man">
                  <div>{{ man.code }} - {{ man.description }}</div>
                </template>
                <template slot="selected-option" slot-scope="man">
                  {{ man.description }}
                </template>
              </v-select>
              <small v-if="$v.job.manufacture_id.$error" class="text-danger">
                Please select manufacture
              </small>
            </form-group>

            <form-group
              :required="true"
              label="Model"
              v-if="
                job.manufacture_id &&
                job.device_type_id &&
                job.device_model_id == null
              "
            >
              <b-skeleton type="input" v-show="loading"></b-skeleton>
              <v-select
                label="description"
                :reduce="(deviceModel) => deviceModel.id"
                :options="
                  deviceModels.filter(
                    (m) =>
                      m.manufacture_id == job.manufacture_id &&
                      m.device_type_id == job.device_type_id
                  )
                "
                v-show="!loading"
                v-model="job.device_model_id"
              >
                <template slot="option" slot-scope="mod">
                  <div>{{ mod.code }} - {{ mod.description }}</div>
                </template>
                <template slot="selected-option" slot-scope="mod">
                  {{ mod.description }}
                </template>
              </v-select>
              <small v-if="$v.job.device_model_id.$error" class="text-danger">
                Please select model
              </small>
            </form-group>

            <form-group label="Model" v-if="job.device_model_id != null">
              <h5>
                {{
                  deviceModels.filter((m) => m.id == job.device_model_id)[0]
                    .description
                }}
              </h5>
            </form-group>

            <form-group label="Pass Code">
              <input type="text" class="form-control" v-model="job.pass_code" />
            </form-group>

            
            <form-group label="Pattern Sequence">
              <input type="text" class="form-control" v-model="job.pattern_sequence" @focus="patternShow=true" @blur="patternShow=false" />
              <img src="@/assets/img/pattern_number.png" v-show="patternShow">
            </form-group>

            <form-group label="IMEI #">
              <input type="text" class="form-control" v-model="job.imei_in" />
              <small v-if="$v.job.imei_in.$error" class="text-danger">
                Please enter IMEI or a SERIAL# (IMEI Should be 15 Characters)
              </small>
           
            </form-group>

            <form-group label="Serial #">
              <input type="text" class="form-control" v-model="job.serial_in" />
              <small v-if="$v.job.serial_in.$error" class="text-danger">
                Please enter IMEI or Serial #
              </small>
            </form-group>

            <form-group label="Symptoms Description" :required="true">
           <textarea-autosize
                class="form-control"
                v-model="job.symptoms_description"
              />
              <small
                v-if="$v.job.symptoms_description.$error"
                class="text-danger"
              >
                Please fill in a description or select options below
              </small>
            </form-group>

            <form-group label="Client reported faults(symptoms)">
              <b-form-checkbox-group
                v-model="selectedSymptoms"
                :options="symptoms"
                value-field="id"
                text-field="description"
                switches
                stacked
              ></b-form-checkbox-group>
            </form-group>
          </template>
        </form-base>
      </tab-content>
      <tab-content
        title="Images & Condition"
        icon="lni lni-image"
        :before-change="imagesVerify"
      >
        <form-base
          class="maxWidth1000"
          :submit-status="submitStatus"
          :errors="errors"
          :loading="loading"
        >
          <template v-slot:fields>
            <form-group label="Condition Description">
        <textarea-autosize
                class="form-control"
                v-model="job.condition_description"
              />
            </form-group>

            <form-group label="Device Condition">
              <b-form-checkbox-group
                v-model="selectedDeviceConditons"
                :options="
                  deviceConditions.filter(
                    (m) =>
                      m.device_type_id == job.device_type_id
                  )"
                value-field="id"
                text-field="description"
                switches
                stacked
              ></b-form-checkbox-group>
            </form-group>

            <form-group label="Device Accessories">
              <b-form-checkbox-group
                v-model="selectedDeviceAccessories"
                :options="
                  deviceAccessories.filter(
                    (m) =>
                      m.device_type_id == job.device_type_id
                  )"
                value-field="id"
                text-field="description"
                switches
                stacked
              ></b-form-checkbox-group>
            </form-group>

            <form-group label="Images">
              <image-upload
                :key="imageComponentKey"
                @files-uploaded="
                  selectedDeviceImages = $event;
                  imageUploading = false;
                "
                @files-uploaded-started="imageUploading = true"
                :multiple="true"
                :imageCrop="false"
                acceptedTypes="image/*"
              />
            </form-group>
          </template>
        </form-base>
      </tab-content>
      <tab-content title="References" icon="lni lni-notepad">
        <form-base
          class="maxWidth1000"
          :submit-status="submitStatus"
          :errors="errors"
          :loading="loading"
        >
          <template v-slot:fields>
            <form-group label="Warranty">
              <b-form-radio v-model="warrantyType" name="warrantyType" value="1"
                >In Warranty</b-form-radio
              >
              <b-form-radio v-model="warrantyType" name="warrantyType" value="0"
                >Out of warranty(inusrance)</b-form-radio
              >
            </form-group>

            <form-group label="POP Supplier" v-if="warrantyType == 1">
              <input class="form-control" v-model="job.pop_supplier" />
            </form-group>

            <form-group label="POP Date" v-if="warrantyType == 1">
              <b-form-datepicker
                id="example-datepicker"
                class="form-control"
                v-model="job.pop_date"
              />
            </form-group>

            <form-group label="Client">
              <input class="form-control" v-model="job.client_reference" />
            </form-group>
            <form-group label="Manufacture">
              <input class="form-control" v-model="job.manufacture_reference" />
            </form-group>
            <form-group label="Job">
              <input class="form-control" v-model="job.job_reference" />
            </form-group>
            <form-group label="Secondary">
              <input class="form-control" v-model="job.secondary_reference" />
            </form-group>
          </template>
        </form-base>

         <b-spinner style="width: 3rem; height: 3rem;" label="Large Spinner" v-if="loading"></b-spinner>

      </tab-content>
    </form-wizard>

    <b-modal
      :hide-footer="true"
      title="Create a client"
      size="lg"
      v-model="createClientShow"
      :no-close-on-route-change="true"
      :lazy="true"
    >
      <client-create @clientCreated="clientCreated"></client-create>
    </b-modal>

     <b-modal
      :hide-footer="true"
      title="Prints"
      size="sm"
      v-model="printShow"
      :no-close-on-route-change="true"
      :lazy="true"
    >
      <b-button variant="primary" @click="vWindow.open(jobCardUrl)">
        Job Card
      </b-button>
      <br><br>
       <b-button variant="primary" @click="vWindow.open(clientJobCardUrl)">
        Client Job Card
      </b-button>
    </b-modal>


  </div>
</template>

<script>
import jobRepo from "@/api/repos/jobRepo";
import { required, requiredIf, email, maxLength, minLength } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";
import clientCreate from "@/views/modules/clients/create";
import imageUpload from "@/components/common/ImageUpload";

export default {
  components: {
    formBase,
    formGroup,
    clientCreate,
    imageUpload,
  },
  computed: {},
  mounted() {
    this.getData();
  },
  data() {
    return {
      printShow:false,
      jobCardUrl:null,
      clientJobCardUrl:null,
      imageComponentKey: 1,
      insuranceJobClient: {},
      selectedPartner: null,
      selectedClient: null,
      clientType: null,
      sidebarToggle: false,
      warrantyType: 0,
      job: {
        is_insurance_job: 0,
        is_shipping_required: 0,
      },
      deviceConditions: [],
      partners: [],
      clients: [],
      deviceAccessories: [],
      manufactures: [],
      deviceTypes: [],
      deviceModels: [],
      symptoms: [],
      selectedSymptoms: [],
      selectedDeviceConditons: [],
      selectedDeviceAccessories: [],
      selectedDeviceImages: [],
      provinces: [],
      errors: null,
      submitStatus: null,
      loading: false,
      imageUploading: false,
      createClientShow: false,
      delayTimer: null,
      patternShow:false
    };
  },

  validations: {
    clientType: {
      required,
    },
    selectedPartner: {
      required: requiredIf(function () {
        return this.clientType == "partner";
      }),
    },
    selectedClient: {
      required: requiredIf(function () {
        return this.clientType == "client";
      }),
    },

    job: {
      is_shipping_required: {
        required,
      },
      scheme_id: {
        required: requiredIf(function () {
          return (
            this.selectedPartner != null &&
            this.selectedPartner.is_insurance_jobs == 1
          );
        }),
      },
      claim_number: {
        required: requiredIf(function () {
          return (
            this.selectedPartner != null &&
            this.selectedPartner.is_insurance_jobs == 1
          );
        }),
      },
      policy_number: {
        required: requiredIf(function () {
          return (
            this.selectedPartner != null &&
            this.selectedPartner.is_insurance_jobs == 1
          );
        }),
      },
      excess_calculation_type: {
        required: requiredIf(function () {
          return (
            this.selectedPartner != null &&
            this.selectedPartner.is_insurance_jobs == 1 &&
            !this.schemeFullCover
          );
        }),
      },
      excess_percentage: {
        required: requiredIf(function (job) {
          return job.excess_calculation_type == "percentage";
        }),
      },
      excess_amount: {
        required: requiredIf(function (job) {
          return job.excess_calculation_type == "amount";
        }),
      },
      device_type_id: {
        required,
      },
      manufacture_id: {
        required,
      },
      device_model_id: {
        required,
      },
      imei_in: {
        required: requiredIf(function (job) {
          return job.serial_in == null;
        }),
        minLength:minLength(15),
        maxLength:maxLength(15)
      },
      serial_in: {
        required: requiredIf(function (job) {
          return job.imei_in == null;
        }),
      },
      symptoms_description: {
        required: requiredIf(function () {
          return this.selectedSymptoms.length == 0;
        }),
      },
    },
    selectedSymptoms: {
      required: requiredIf(function () {
        return this.job.symptoms_description == null;
      }),
    },
    insuranceJobClient: {
      name: {
        required: requiredIf(function () {
          return (
            this.selectedPartner != null &&
            this.selectedPartner.is_insurance_jobs == 1
          );
        }),
      },
      surname: {
        required: requiredIf(function () {
          return (
            this.selectedPartner != null &&
            this.selectedPartner.is_insurance_jobs == 1
          );
        }),
      },

      contact_number: {
        required: requiredIf(function () {
          return (
            this.selectedPartner != null &&
            this.selectedPartner.is_insurance_jobs == 1
          );
        }),
      },

      email_address: {
        required: requiredIf(function () {
          return (
            this.selectedPartner != null &&
            this.selectedPartner.is_insurance_jobs == 1
          );
        }),
        email:email,
      },

      address: {
        required: requiredIf(function () {
          return (
            this.selectedPartner != null &&
            this.selectedPartner.is_insurance_jobs == 1
          );
        }),
      },

      postal_code: {
        required: requiredIf(function () {
          return (
            this.selectedPartner != null &&
            this.selectedPartner.is_insurance_jobs == 1
          );
        }),
      },

      province_id: {
        required: requiredIf(function () {
          return (
            this.selectedPartner != null &&
            this.selectedPartner.is_insurance_jobs == 1
          );
        }),
      },
    },
  },

  methods: {
    async getData() {
      try {
        this.loading = true;
        let { data } = await jobRepo.booking();
        this.deviceConditions = data.device_conditions;
        this.deviceAccessories = data.device_accessories;
        this.manufactures = data.manufactures;
        this.deviceTypes = data.device_types;
        this.symptoms = data.symptoms;
        this.provinces = data.provinces;
        this.deviceModels = data.device_models;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async getPartners() {
      this.selectedClient = null;
      this.job = {};
      try {
        this.loading = true;
        let { data } = await jobRepo.getPartners();
        this.partners = data.partners;
      } finally {
        this.loading = false;
      }
    },

    getClients(search) {
      this.selectedPartner = null;
      if (search.length > 1) {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(() => {
          this.clientSearch(search);
        }, 500);
      }
    },

    async clientSearch(search) {
      try {
        let { data } = await jobRepo.getClients(search);
        this.clients = data.clients;
      } finally {
        this.loading = false;
      }
    },

    clientCreate() {
      this.createClientShow = true;
    },

    clientCreated(client) {
      this.createClientShow = false;
      this.selectedClient = client;
    },

    schemeFullCover() {
      if (this.job.scheme_id != null && this.selectedPartner != null) {
        let selectedScheme = this.selectedPartner.schemes.filter((s) => {
          return s.id == this.job.scheme_id;
        });
        selectedScheme = selectedScheme[0];
        if (selectedScheme.full_cover == 1) {
          return true;
        } else {
          return false;
        }
      }
    },

    async typeAndClientVerify() {
      if (
        this.$v.clientType.$invalid ||
        this.$v.selectedPartner.$invalid ||
        this.$v.selectedClient.$invalid ||
        this.$v.job.is_shipping_required.$invalid ||
        this.$v.job.claim_number.$invalid ||
        this.$v.job.policy_number.$invalid ||
        this.$v.job.scheme_id.$invalid ||
        this.$v.job.excess_calculation_type.$invalid ||
        this.$v.job.excess_percentage.$invalid ||
        this.$v.job.excess_amount.$invalid ||
        this.$v.insuranceJobClient.name.$invalid ||
        this.$v.insuranceJobClient.surname.$invalid ||
        this.$v.insuranceJobClient.contact_number.$invalid
      ) {
        this.$v.clientType.$touch();
        this.$v.selectedPartner.$touch();
        this.$v.selectedClient.$touch();
        this.$v.job.is_shipping_required.$touch();
        this.$v.job.claim_number.$touch();
        this.$v.job.policy_number.$touch();
        this.$v.job.scheme_id.$touch();
        this.$v.job.excess_calculation_type.$touch();
        this.$v.job.excess_percentage.$touch();
        this.$v.job.excess_amount.$touch();
        this.$v.insuranceJobClient.name.$touch();
        this.$v.insuranceJobClient.surname.$touch();
        this.$v.insuranceJobClient.contact_number.$touch();
        this.$v.insuranceJobClient.email_address.$touch();
        this.$v.insuranceJobClient.province_id.$touch();
        this.$v.insuranceJobClient.address.$touch();
        this.$v.insuranceJobClient.postal_code.$touch();

        this.$root.$bvToast.toast("Form Errors", {
          title: "Errors on form data",
          autoHideDelay: 2000,
          variant: "danger",
        });

        return false;
      }
      window.scrollTo(0,0);
      return true;
    },

    async deviceVerify() {
      if (
        this.$v.job.manufacture_id.$invalid ||
        this.$v.job.device_model_id.$invalid ||
        this.$v.job.device_type_id.$invalid ||
        this.$v.job.symptoms_description.$invalid ||
        this.$v.selectedSymptoms.$invalid ||
        this.$v.job.imei_in.$invalid ||
        this.$v.job.serial_in.$invalid
      ) {
        this.$v.job.manufacture_id.$touch();
        this.$v.job.device_model_id.$touch();
        this.$v.job.device_type_id.$touch();
        this.$v.job.symptoms_description.$touch();
        this.$v.job.imei_in.$touch();
        this.$v.job.serial_in.$touch();

        this.$root.$bvToast.toast("Form Errors", {
          title: "Errors on form data",
          autoHideDelay: 2000,
          variant: "danger",
        });

        return false;
      }
      window.scrollTo(0,0);
      return true;
    },

    async imagesVerify() {
      if (this.imageUploading) {
        this.$root.$bvToast.toast("Images Uploading", {
          title: "Please wait for images to upload",
          autoHideDelay: 2000,
          variant: "warning",
        });
        return false;
      } else {
        window.scrollTo(0,0);
        return true;
      }
    },

    async submitJob() {
      if(this.loading){return false;}
      try {
        this.loading = true;

        if (
          this.selectedDeviceImages != null &&
          this.selectedDeviceImages.length > 0
        ) {
          this.job.job_images = this.selectedDeviceImages.split(",");
        }

        this.job.symptoms = this.selectedSymptoms;
        this.job.device_conditions = this.selectedDeviceConditons;
        this.job.device_accessories = this.selectedDeviceAccessories;
        this.job.insurance_job_client = this.insuranceJobClient;
        this.job.is_in_warranty = this.warrantyType;

        if (this.selectedPartner != null) {
          this.job.partner_id = this.selectedPartner.id;
        }

        if (this.selectedClient != null) {
          this.job.client_id = this.selectedClient.id;
        }

        let {data} = await jobRepo.create(this.job);

        this.printShow=true

        this.jobCardUrl=`/pdf/reports/job/${data.uid}/job-card?cid=${data.cid}`
        this.clientJobCardUrl=`/pdf/reports/job/${data.uid}/client-job-card?cid=${data.cid}`

        this.$root.$bvToast.toast("Success", {
          title: "Job Booked In",
          autoHideDelay: 2000,
          variant: "success",
        });
      } catch (error) {
        this.$root.$bvToast.toast("Whoops", {
          title: "Something went wrong",
          autoHideDelay: 2000,
          variant: "danger",
        });
        console.log(error);
      } finally {
          this.$refs.wizard.reset();
        this.selectedSymptoms = [];
        this.selectedDeviceConditons = [];
        this.selectedDeviceAccessories = [];
        this.selectedDeviceImages = [];
        this.imageComponentKey++;
        this.selectedPartner = null;
        this.selectedClient = null;
        this.clientType = null;
        this.job = {};
        this.insuranceJobClient = {};
  

        this.loading = false;
      }
    },

    clearModel() {
      if (this.job.device_model_id != null) {
        this.job.device_model_id = null;
      }
    },
  },

  watch: {
    selectedPartner: {
      immediate: true,
      handler: function (newVal) {
        this.job = {};
        if (newVal != null) {
          if (this.selectedPartner.is_shipping_required == 1) {
            this.job.is_shipping_required = 1;
          } else {
            this.job.is_shipping_required = 0;
          }
          if (this.selectedPartner.is_insurance_jobs == 1) {
            this.job.is_insurance_job = 1;
          } else {
            this.job.is_insurance_job = 0;
          }
        }
      },
    },
  },

  selectedClient: {
    immediate: true,
    handler: function () {
      this.job = {};
    },
  },
};
</script>


